import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const BirthIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M1,8.47A5.28,5.28,0,0,1,2.57,4.56,5.36,5.36,0,0,1,6.5,3,5.68,5.68,0,0,1,9,3.55,5.92,5.92,0,0,1,11,5.1a6,6,0,0,1,2-1.55A5.75,5.75,0,0,1,15.5,3a5.22,5.22,0,0,1,3.05.89,5.68,5.68,0,0,1,1.93,2.28A1,1,0,0,1,20,7.5a.94.94,0,0,1-.77,0A1,1,0,0,1,18.65,7a3.11,3.11,0,0,0-1.33-1.5,3.64,3.64,0,0,0-3.92.15,7,7,0,0,0-1.65,1.6.72.72,0,0,1-.33.29,1,1,0,0,1-.42.08.94.94,0,0,1-.43-.1.76.76,0,0,1-.32-.27A7,7,0,0,0,8.6,5.65,3.65,3.65,0,0,0,6.5,5,3.44,3.44,0,0,0,4,6,3.28,3.28,0,0,0,3,8.47a4.48,4.48,0,0,0,.35,1.68,8.11,8.11,0,0,0,1.25,2,29.79,29.79,0,0,0,2.45,2.6Q8.6,16.2,11,18.3l2.22-1.95a.92.92,0,0,1,.7-.25,1,1,0,0,1,.68.3,1,1,0,0,1,.29.74.92.92,0,0,1-.34.71l-2.23,2a1.86,1.86,0,0,1-.62.37,1.95,1.95,0,0,1-1.4,0,1.77,1.77,0,0,1-.63-.4c-.75-.67-1.62-1.42-2.61-2.27a34.9,34.9,0,0,1-2.84-2.74,17.55,17.55,0,0,1-2.28-3.07A6.3,6.3,0,0,1,1,8.47ZM18,14H16a1,1,0,1,1,0-2h2V10a1,1,0,1,1,2,0v2h2a1,1,0,1,1,0,2H20v2a1,1,0,1,1-2,0Z" />
    </SvgIcon>
  )
}
export default BirthIcon
